function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.822 31a1.5 1.5 0 0 1-1.333-2.19L14.668 1.4a1.5 1.5 0 0 1 2.664 0l14.179 27.41A1.5 1.5 0 0 1 30.178 31H1.822zM16 3.177L2.643 29h26.714L16 3.177zM16 11a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1zm0 15.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
});

var SvgAlertCaution = function SvgAlertCaution(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "4c8e412ee30308638e55bfd0c4a06782.svg";
export { SvgAlertCaution as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/alert-caution.svg
// module id = null
// module chunks = 